export default [
  { label: 'Salud', value: 'health' },
  { label: 'Educación', value: 'education' },
  { label: 'Deportes', value: 'sport' },
  { label: 'Entretenimiento', value: 'entertainment' },
  { label: 'Gastronomía', value: 'gastronomy' },
  { label: 'Servicios', value: 'services' }
];
